<template>
  <div class="bg-black h-screen flex items-center justify-center">
    <div class="slide absolute top-0 left-0">
      <transition name="slide" appear>
        <div class="slide__item" :key="index"><img :src="slide[index]" alt=""></div>
      </transition>
    </div>
  </div>

</template>

<script>
import slide_1 from "../assets/top/hero/slide_1.jpg"
import slide_2 from "../assets/top/hero/slide_2.jpg"
import slide_3 from "../assets/top/hero/slide_3.jpg"
import slide_4 from "../assets/top/hero/slide_4.jpg"
import slide_5 from "../assets/top/hero/slide_5.jpg"
import slide_6 from "../assets/top/hero/slide_6.jpg"
import slide_7 from "../assets/top/hero/slide_7.jpg"
import slide_8 from "../assets/top/hero/slide_8.jpg"
import slide_9 from "../assets/top/hero/slide_9.jpg"


export default {
  name: "Hero",
  data() {
    return {
      index: 0,
      slide: [
        slide_1,slide_2,slide_3,slide_4,slide_5,slide_6,slide_7,slide_8,slide_9
      ]
    }
  },
  async mounted() {
    window.setInterval(this.turning, 5000);
  },
  methods: {
    turning() {
      if(this.slide.length - 1 > this.index) {
        this.index++
      } else {
        this.index = 0
      }
    }
  }
}
</script>

<style>
.slide{
  @apply w-full h-screen;
}
.slide__item {
  @apply h-screen absolute top-0 w-full bg-darkgray;
  transform-origin: center center;
}
.slide__item img {
  @apply max-w-none object-cover h-screen w-full;
  object-position: center center;
}

.slide-enter-active,
.slide-leave-active {
  transition: opacity 1s ease;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
}

.slide__item{
  animation: zoomUp 6s linear 0s both;
}



@keyframes zoomUp {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.1);
  }
}

</style>